import Input from '../../../components/Input';
import { extractVariablesFromTemplate } from './promptTemplateUtils';

const PromptTemplateDetails = ({
  record,
  templatesByType,
  availableAreaVariables,
  onFieldChange,
  onTemplateChange,
}) => {
  const variablesInTemplate = extractVariablesFromTemplate(
    [
      templatesByType.system.template,
      templatesByType.user.template,
      templatesByType.assistant.template,
    ]
      .filter(Boolean)
      .join('\n')
  );

  return (
    <div className="record-form-fields-container">
      <div className="input-control separate-label">
        <label htmlFor="category">
          Area
          <span className="required">*</span>
        </label>
        <Input
          type="text"
          label={null}
          name="category"
          value={record.category ?? ''}
          onChange={(val) => onFieldChange('category', val)}
          isRequired={true}
        />
        <div className="input-help-text">
          Where this prompt is used, e.g. <strong>Content Blog</strong>, <strong>Content FAQ</strong>, <strong>Campaign</strong>.
        </div>
      </div>

      <div className="input-control separate-label">
        <label htmlFor="name">
          Template Name
          <span className="required">*</span>
        </label>
        <Input
          type="text"
          label={null}
          name="name"
          value={record.name ?? ''}
          onChange={(val) => onFieldChange('name', val)}
          isRequired={true}
        />
        <div className="input-help-text">
          Human-friendly name that appears in the list, e.g. <strong>Blog</strong>, <strong>FAQ Instructions</strong>.
        </div>
      </div>

      <div className="input-control separate-label">
        <label htmlFor="variablesHelp">Usage / Variable Notes (optional)</label>
        <Input
          type="textarea"
          label={null}
          name="variablesHelp"
          value={record.variablesHelp ?? ''}
          onChange={(val) => onFieldChange('variablesHelp', val)}
          toolTipText="Explain what this prompt does and what each {{variable}} represents."
        />
        <div className="input-help-text">
          Describe where the prompt is shown and document variables like <code>{'{{companyName}}'}</code>, <code>{'{{campaignName}}'}</code>.
        </div>
      </div>

      {availableAreaVariables.length > 0 && (
        <div className="input-control separate-label">
          <label>Available Variables for this Area</label>
          <div className="prompt-template-variables">
            {availableAreaVariables.map((v) => {
              const isUsed = variablesInTemplate.includes(v);
              return (
                <span
                  key={v}
                  className="prompt-template-variable-pill"
                  style={{
                    textDecoration: isUsed ? 'line-through' : 'none',
                    opacity: isUsed ? 0.6 : 1,
                  }}
                >
                  <code>{`{{${v}}}`}</code>
                </span>
              );
            })}
          </div>
          <div className="input-help-text">
            These variables can be used inside any of the prompts above as <code>{'{{variableName}}'}</code>. The backend will automatically replace them with the correct values when generating content.
          </div>
        </div>
      )}

      <div className="input-control separate-label">
        <label htmlFor="systemTemplate">
          System Prompt
          <span className="required">*</span>
        </label>
        <Input
          type="textarea"
          label={null}
          name="systemTemplate"
          value={templatesByType.system.template}
          onChange={(val) => onTemplateChange('system', val)}
          isRequired={true}
          style={{ minHeight: '200px' }}
        />
      </div>

      <div className="input-control separate-label">
        <label htmlFor="userTemplate">User Prompt</label>
        <Input
          type="textarea"
          label={null}
          name="userTemplate"
          value={templatesByType.user.template}
          onChange={(val) => onTemplateChange('user', val)}
          style={{ minHeight: '160px' }}
        />
      </div>

      <div className="input-control separate-label">
        <label htmlFor="assistantTemplate">Assistant Prompt (optional)</label>
        <Input
          type="textarea"
          label={null}
          name="assistantTemplate"
          value={templatesByType.assistant.template}
          onChange={(val) => onTemplateChange('assistant', val)}
          style={{ minHeight: '120px' }}
        />
      </div>

    </div>
  );
};

export default PromptTemplateDetails;
